import { useState } from "react";
import { toast } from "../hooks/use-toast";
import api from "../services/api";
import { useNavigate, useParams } from "react-router-dom";

const AdminResetPassword = () => {
  const navigate = useNavigate();
  const { userId } = useParams();
  const [formData, setFormData] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.newPassword !== formData.confirmPassword) {
      toast({
        title: "Error",
        description: "Passwords do not match",
        variant: "destructive",
      });
      return;
    }
    setLoading(true);
    try {
      await api.post(`/password/reset-password/${userId}`, formData);
      toast({
        title: "Success",
        description: "Password reset successfully",
      });
      navigate("/login");
    } catch (err) {
      toast({
        title: "Error",
        description: err.response?.data?.message || "Failed to reset password",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-custom py-20">
      <div className="max-w-md mx-auto bg-card p-8 rounded-2xl shadow-soft">
        <h2 className="text-xl font-semibold mb-4">Reset Password</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="password"
            placeholder="New Password"
            value={formData.newPassword}
            onChange={(e) =>
              setFormData({ ...formData, newPassword: e.target.value })
            }
            required
            className="w-full px-4 py-3 rounded-xl border border-border focus:border-primary outline-none"
          />
          <input
            type="password"
            placeholder="Confirm Password"
            value={formData.confirmPassword}
            onChange={(e) =>
              setFormData({ ...formData, confirmPassword: e.target.value })
            }
            required
            className="w-full px-4 py-3 rounded-xl border border-border focus:border-primary outline-none"
          />
          <button type="submit" className="btn-hero w-full" disabled={loading}>
            {loading ? "Resetting..." : "Reset Password"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminResetPassword;
